import { TInitialState } from '~/src/features/tariffBuilder/reducer';

const selectClientName = (clientPersonalName = '') => (state: TInitialState) => {
    if (state.currentTariff) {
        return clientPersonalName;
    }
    return state.client.name;
};

export default selectClientName;
